import styled from 'styled-components';
import { pxToRem } from 'utils/convert';

const configureSvgStyling = (color: string) => `
    > svg {
      color: ${color} !important;
    }
`;

const adjustIcon = (name: string, color: string) => `
 .click-to-${name} {
    .click-to-${name}-icon {
      > svg {
        position: relative;
        top: ${pxToRem(3)};
        fill: ${color} !important;
      }
    }
  }
`;

export const JSONTreeContainer = styled.div`
  > .react-json-view {
    background-color: transparent !important;
    border-radius: ${pxToRem(3)};
    padding: ${pxToRem(5)} ${pxToRem(5)} ${pxToRem(5)} ${pxToRem(23)} !important;
    .pretty-json-container * {
      background-color: transparent !important;
      letter-spacing: normal !important;
      opacity: 1 !important;
      .object-content {
        word-break: break-word;
      }
      .edit-cancel {
        padding-top: ${pxToRem(20)};
        display: inline-block;
      }
    }
  }
  &[data-monospace='true'] > .react-json-view {
    font-family: 'Inconsolata', 'Courier New', 'Menlo', Monaco, monospace !important;
  }
  &[data-indentation='false'] > .react-json-view {
    .object-key-val,
    .variable-row {
      border-left: none !important;
    }
  }
  &[data-quotes='false'] > .react-json-view {
    .object-key {
      span:first-child {
        display: none;
      }
      span:last-child {
        display: none;
      }
    }
  }
  &[data-key-trailing-spaces='true'] > .react-json-view {
    .object-key {
      & > span {
        white-space: pre;
      }
    }
  }
  &[data-root='false'] > .react-json-view {
    padding-left: ${pxToRem(5)} !important;
    > .object-container {
      > .object-content {
        > .object-key-val {
          > span:first-child,
          > .brace-row {
            display: none;
          }
          > .pushed-content {
            > .object-content {
              margin-left: ${pxToRem(2)} !important;
            }
          }
        }
      }
    }
  }
  .data-type-label {
    font-weight: bold;
  }
  .icon-container {
    margin-left: -${pxToRem(17)};

    .collapsed-icon,
    .expanded-icon {
      ${configureSvgStyling('#2e8ece')};
      position: relative;
      top: ${pxToRem(2)};
    }
  }
  .object-key {
    letter-spacing: normal;
  }
  .object-key-val,
  .variable-row {
    ${adjustIcon('add', '#2cc36b')}
    ${adjustIcon('edit', '#e98b39')}
      ${adjustIcon('remove', '#d14233')}
  }
  .variable-row {
    .variable-value {
      .edit-cancel {
        ${configureSvgStyling('#717171')}
      }
      .edit-check {
        ${configureSvgStyling('#2cc36b')}
      }
      .edit-cancel,
      .edit-check {
        > svg {
          height: ${pxToRem(20)} !important;
          width: ${pxToRem(20)} !important;
        }
      }
      .edit-cancel + .edit-check + div:not(:empty) {
        display: inline-block;
        margin-left: ${pxToRem(10)};
        vertical-align: middle;

        > div > div {
          padding: 0 !important;
        }
      }
      /* stylelint-disable selector-pseudo-class-no-unknown */
      :global(.variable-editor) {
        color: #616161 !important;
        line-height: 1 !important;
        margin-bottom: -${pxToRem(10)};
        &:focus {
          outline: none;
          border-color: #2383ce;
        }
      }
    }
  }
  .key-modal-request {
    > div {
      background: #fff !important;
      border: ${pxToRem(1)} solid #c3c3c5;
      box-shadow: 0 0 ${pxToRem(2)} #999;
      > div:first-child {
        font-weight: bold;
      }
      > span {
        background-color: transparent !important;
        top: ${pxToRem(5)} !important;
        right: ${pxToRem(5)} !important;
      }
    }
    .key-modal-input {
      border: ${pxToRem(1)} solid #c3c3c5 !important;
      color: #616161 !important;
      &:focus {
        outline: 0;
        border-color: #2383ce !important;
      }
    }
    :global(.key-modal-submit) {
      ${configureSvgStyling('#2cc36b')}
      > svg {
        top: ${pxToRem(5)} !important;
      }
    }
  }
`;
